import { getConversationById } from '@app/helpers'
import { Message } from '@app/models'

import { getUpdateAt } from '@lib/utils'

import { ChatState, SendMessageSuccessPayload } from '../types'

export const onSendMessageSuccess = (
  state: ChatState,
  payload: SendMessageSuccessPayload
): ChatState => {
  const { acsChatMessageId, conversationId, uuid, id } = payload

  const conversation = getConversationById(state.conversations, conversationId)
  if (!conversation) {
    return state
  }

  const updateDate = getUpdateAt()
  const messageIndex = conversation.messages.findIndex(
    (item) => item.uuid === uuid
  )
  if (messageIndex === -1) {
    return state
  }

  const message: Message = {
    ...conversation.messages[messageIndex],
    acsChatMessageId,
    updateDate,
    id,
    sendStatus: 'Sent',
  }

  const messages: Message[] = [
    ...conversation.messages.slice(0, messageIndex),
    message,
    ...conversation.messages.slice(messageIndex + 1),
  ]

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...conversation,
        messages,
        updateDate,
        replyDetectionStatus: 'Replied',
      },
    },
  }
}
